import { Box, Text } from '@nimbus-ds/components';
import { DataList } from '@nimbus-ds/patterns';
import { useTranslation } from 'react-i18next';
import { PriceTableDto } from '@tiendanube/common';
import { Domain } from '@tiendanube/common/src/enums';
import { Label } from '@tiendanube/components';

interface CustomerPriceTablesItemProps {
  priceTable: PriceTableDto;
}

export default function CustomerPriceTablesItem({
  priceTable,
}: Readonly<CustomerPriceTablesItemProps>) {
  const { t } = useTranslation(Domain.CUSTOMERS);
  const tPath = 'customerDetails.customerPriceTables';

  return (
    <DataList.Row id={priceTable.id}>
      <Text fontWeight="bold">{priceTable.name}</Text>
      <Text>
        {priceTable.defaultValue}
        {t(`${tPath}.reductionPriceText`)}
      </Text>
      <Box display="flex" gap="2" marginTop="0-5">
        <Label
          id="activeLabel"
          label={t(
            `${tPath}.${priceTable.active ? 'activeLabel' : 'inactiveLabel'}`,
          )}
          appearance={priceTable.active ? 'success' : 'default'}
        />
      </Box>
    </DataList.Row>
  );
}
